import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import { withRouter } from "../../utils/withRouterCompat"
;
import { connect } from "react-redux";
import { Box, Button, Container, CssBaseline, Typography, TextField, Backdrop, CircularProgress } from "@mui/material";
import Alert from '@mui/material/Alert';

import { login, temporaryLogin } from "../../redux/auth/actions.js";
import * as api from "../../redux/api/actions.js";
import ZoetisLogo from "../../assets/img/logo_corte.png";

class TemporaryLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      redirectToGigya: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange = (event) => {
    const {
      target: { name, value },
    } = event;
    this.setState(() => ({ [name]: value }));
  };

  async handleSubmit() {
    const { email, password } = this.state;
    // Esta é uma nova action que precisará ser criada no Redux
    // e apontará para o endpoint `Authentication/temporary-login`
    await this.props.temporaryLogin({ login: email, password });
  }

  onEnterPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey && this.canSubmit()) {
      e.preventDefault();
      this.handleSubmit();
    }
  };

  canSubmit() {
    return this.state.email && this.state.password;
  }

  componentDidUpdate(prevProps) {
    if (this.props.success && !prevProps.success) {
      this.setState({ redirectToGigya: true });
    }
  }

  render() {
    if (this.state.redirectToGigya) {
      return (
        <Navigate
          to="/register-gigya"
          state={{ isFirstLogin: true }}
          replace
        />
      );
    }

    if (this.props.loading) {
      return (
        <Backdrop open>
          <CircularProgress color="inherit" />
        </Backdrop>
      );
    }

    return (
      <>
        <CssBaseline />
        <Box
          sx={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: 'background.default',
            px: 2,
            py: 4,
          }}
        >
          <Container maxWidth='xs' disableGutters>
            <Box
              sx={{
                bgcolor: 'background.paper',
                borderRadius: 2,
                boxShadow: 1,
                p: { xs: 3, sm: 4 },
              }}
            >
                <Typography component='div'>
                  <img
                    src={ZoetisLogo}
                    alt="Zoetis Gerar"
                    className="p-full-width"
                    style={{ width: "100%" }}
                  />

                  <Typography
                    variant="h6"
                    style={{ textAlign: "center", margin: "1em 0" }}
                  >
                    Acesso Inicial
                  </Typography>

                  {this.props.error && (
                    <Alert severity="error" style={{ marginTop: "1em" }}>
                      {this.props.error.title}
                    </Alert>
                  )}

                  <Container disableGutters>
                    <Container disableGutters style={{ marginTop: "1em" }}>
                      <TextField
                        id="email"
                        label="E-mail"
                        name="email"
                        variant="outlined"
                        type="email"
                        onChange={this.handleChange}
                        value={this.state.email}
                        style={{ width: "100%", backgroundColor: "white" }}
                      />
                    </Container>

                    <Container disableGutters style={{ marginTop: "1em" }}>
                      <TextField
                        id="password"
                        label="Senha Temporária"
                        name="password"
                        variant="outlined"
                        type="password"
                        onChange={this.handleChange}
                        onKeyDown={this.onEnterPress}
                        style={{
                          width: "100%",
                          backgroundColor: "white",
                        }}
                      />
                    </Container>

                    <Container disableGutters style={{ marginTop: "1em" }}>
                      <Button
                        variant="contained"
                        color="primary"
                        size="large"
                        style={{ width: "100%" }}
                        disabled={!this.canSubmit() || this.props.loading}
                        onClick={this.handleSubmit}
                      >
                        Entrar
                      </Button>
                    </Container>
                  </Container>
                </Typography>
            </Box>
          </Container>
        </Box>
      </>
    );
  }
}

// Atualizar mapDispatchToProps
const mapDispatchToProps = (dispatch) => {
  return {
    temporaryLogin: (params) => dispatch(temporaryLogin(params)),
  };
};

const mapStateToProps = (state) => ({
  error: api.getApiError(state, `Authentication/temporary-login`) || false,
  success: api.getApiResult(state, `Authentication/temporary-login`) || false,
  loading: api.getApiLoading(state, `Authentication/temporary-login`),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(TemporaryLogin));
